<template>
  <div
    v-if="page_stage === 'prepare' && no_refusal"
    class="prepare_page"
    :class="{ 'is-visible': isPageLoaded, 'is-videoresume': isVideoresume }"
  >
    <div v-if="landing.is_active" id="registration-content" class="container tightContainer">
      <div class="landing_content_block">
        <div
          ref="description_wrapper"
          v-images-loaded="imageLoaded"
          class="description-wrapper"
          :class="{ 'is-hidden': !shouldShowDescr }"
          :style="{ maxHeight: !showToggleDescriptionButton ? 'none' : maxHeight + 'px' }"
        >
          <div v-if="company_logo" class="interview_top_block">
            <div v-if="company_logo" class="image">
              <img :src="company_logo" alt="vcv" />
            </div>
          </div>

          <video-container v-if="landing.video_link && landing.is_video_landing" :vacancy-video="landing.video_link" />

          <div v-if="landing.logo_url && !landing.is_video_landing" class="vacancy-logo">
            <img :src="landing.logo_url" alt="Vacancy logo" />
          </div>

          <div v-if="landing.name" class="greet">
            <h1>{{ landing.name }}</h1>
          </div>

          <div
            v-if="landing.description"
            ref="description"
            class="description description-text"
            v-html="landing.description"
          ></div>
        </div>

        <div
          v-if="showToggleDescriptionButton && page_type === 'interview'"
          class="toggle-description-link"
          @click="toggleDescription"
        >
          <span :class="{ 'is-hidden': !isDescrVisible }">
            {{
              isVideoresume
                ? $tr('interview.landing.modules.hideDescrVideoresume')
                : $tr('interview.landing.modules.hideDescr')
            }}
          </span>
          <span :class="{ 'is-hidden': isDescrVisible }">
            {{
              isVideoresume
                ? $tr('interview.landing.modules.showDescrVideoresume')
                : $tr('interview.landing.modules.showDescr')
            }}
          </span>
        </div>

        <div id="modules" class="landing_modules">
          <div class="landing_modules_title" :class="{ 'landing-title': page_type === 'landing' }">
            {{ landingTitle }}
          </div>
          <div>
            <div
              v-if="reg && vacancyStatus.canRegister && page_type !== 'interview'"
              class="landing_module"
              :class="{ reg }"
            >
              <registration
                :company-info="landing"
                :locale="locale"
                :country="vacancy_country"
                :is_japan_locale="is_japan_locale"
                :loading="loading"
                :custom-errors="customErrors"
                :is-videoresume="isVideoresume"
                :sitekey="sitekey"
                :recaptcha_res="recaptcha_res"
                :disabled="disabled"
                :show_captcha="show_captcha"
                :error_code="error_code"
                @check_captcha="check_captcha"
                @reset_captcha="reset_captcha"
                @keyup="customErrors = null"
                @onSubmit="handleSubmit"
              />
            </div>
            <template v-if="page_type !== 'landing'">
              <stage
                v-for="item in modules"
                :key="item.id"
                :item="item"
                :active-modules="activeModules"
                :company-info="landing"
                :interview="interview"
                :is-disabled="isStagesDisabled"
                :loading="stageLoading"
                :is-videoresume="isVideoresume"
                :is-resume-mandatory="isResumeMandatory"
                :is-resume-finished="isResumeFinished"
                :has-valid-resume="hasValidResume"
                @goto="set_page_stage"
                @uploadResume="uploadResume"
                @uploadResumeUrl="uploadResumeUrl"
                @setError="setError"
                @setResumeName="setResumeName"
                @resetFile="resetFile"
              />
              <div v-if="isVideoresume && !isAllModulesFinished" class="stages-footer">
                <vresume-button
                  class="interview_button"
                  :text="$tr('vacancy.openRegistrationVideoresume.register')"
                  :disabled="loading"
                  :loading="loading"
                  @click="goToCurrentStage"
                />
              </div>
            </template>
          </div>
        </div>
      </div>

      <div v-if="!vacancyStatus.canRegister" class="closed">{{ vacancyStatus.text }}</div>

      <template v-if="vacancyStatus.canRegister">
        <div v-if="isVideoresume ? !!(page_type === 'landing') : true" class="landing_share">
          <div class="vacancy-share">
            <template v-if="isDomainRu">
              <social-sharing :url="custom_link" inline-template>
                <div class="sharing-list-wrapper">
                  <div
                    class="sharing-list"
                    :title="isVideoresume ? $tr('vacancy.openRegistrationVideoresume.shareVacancy') : ''"
                  >
                    <!-- <network network="facebook">
                      <svg class="round-icon">
                      <use xlink:href="/static/icons/round-icons.svg#facebook" />
                      </svg>
                      </network> -->
                    <network network="vk">
                      <svg class="round-icon">
                        <use xlink:href="/static/icons/round-icons.svg#vk" />
                      </svg>
                    </network>
                    <!-- <network network="linkedin">
                      <svg class="round-icon">
                      <use xlink:href="/static/icons/round-icons.svg#linkedin" />
                      </svg>
                      </network> -->
                  </div>
                </div>
              </social-sharing>
            </template>

            <template v-else>
              <social-sharing :url="custom_link" inline-template>
                <div class="sharing-list-wrapper">
                  <div class="sharing-list" :title="$tr('vacancy.openRegistrationVideoresume.shareVacancy')">
                    <network network="facebook">
                      <svg class="round-icon">
                        <use xlink:href="/static/icons/round-icons.svg#facebook" />
                      </svg>
                    </network>

                    <network network="twitter">
                      <svg class="round-icon">
                        <use xlink:href="/static/icons/round-icons.svg#twitter" />
                      </svg>
                    </network>

                    <network network="linkedin">
                      <svg class="round-icon">
                        <use xlink:href="/static/icons/round-icons.svg#linkedin" />
                      </svg>
                    </network>
                  </div>
                </div>
              </social-sharing>
            </template>
          </div>
        </div>
      </template>
    </div>

    <div v-else id="registration-content">
      <v-app>
        <v-container class="container-fixed">
          <v-row justify="center">
            <v-col sm="4" md="4" lg="4">
              <div class="inner_wrapper">
                <v-container class="container-fixed">
                  <v-row justify="center">
                    <v-col sm="4" md="4" lg="4">
                      <div
                        ref="description_wrapper"
                        v-images-loaded="imageLoaded"
                        class="description-wrapper"
                        :class="{ 'is-hidden': !shouldShowDescr }"
                        :style="{
                          maxHeight: !showToggleDescriptionButton ? 'none' : maxHeight + 'px'
                        }"
                      >
                        <div v-if="company_logo" class="interview_top_block">
                          <div v-if="company_logo" class="image">
                            <img :src="company_logo" alt="vcv" />
                          </div>
                        </div>

                        <div v-if="landing.logo_url && !landing.is_video_landing" class="vacancy-logo">
                          <img :src="landing.logo_url" alt="Vacancy logo" />
                        </div>

                        <div v-if="landing.name" class="greet">
                          <h1>{{ landing.name }}</h1>
                        </div>

                        <div v-if="!vacancyStatus.canRegister" class="closed">
                          {{ vacancyStatus.text }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-app>
    </div>
  </div>

  <div v-else-if="!no_refusal" class="refuse-container">
    <div class="refuse-container__wrap">
      <img src="/static/images/elements/icon_ok.png" />
      <div class="refuse-container__title">{{ $tr('vacancy.preferences.refuse.answer') }}</div>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import imagesLoaded from 'vue-images-loaded';
import { mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';
import { STORE_PREFIX } from './constants.js';
import { isDomainRu, handleError } from '@/_helpers/utils.js';
import registration from './components/register-form/index';
import stage from './components/stage';
import videoContainer from './components/videoContainer';
import axios from 'axios';

export default {
  name: 'PrepareDefault',

  components: {
    // greeting,
    registration,
    stage,
    videoContainer
  },

  directives: {
    imagesLoaded
  },

  props: {
    page_type: {
      type: String,
      default: 'landing'
    },

    fromRegistration: {
      type: Boolean,
      default: false
    },

    startGoto: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      reg: true,
      page_stage: 'prepare',
      customErrors: null,
      isDescrVisible: true,
      showToggleDescriptionButton: true,
      isPageLoaded: false,
      maxHeight: 20000,
      isImagesLoaded: false,
      resumeFile: null,
      resumeUrl: '',
      isResumeUploaded: false,
      stageLoading: false,
      resumevalError: false,
      hasResumeName: false,
      isSettingWrapperHeight: false,
      sitekey: process.env.recapcha_key,
      recaptcha_res: null,
      disabled: false,
      show_captcha: false,
      error_code: null
    };
  },

  computed: {
    ...mapGetters('landing', {
      landing: 'item',
      landing_token: 'token',
      loading: 'loaded'
    }),

    ...mapGetters(STORE_PREFIX + 'interview', {
      interview: 'item',
      isInterviewVideoresume: 'isVideoresume',
      interview_token: 'token'
    }),

    ...mapGetters('process', ['getProcessName']),

    landingTitle() {
      if (!this.isVideoresume) {
        return this.page_type === 'landing'
          ? this.$tr('interview.landing.modules.prepare.title')
          : this.$tr('interview.landing.modules.title');
      } else {
        return this.page_type === 'landing'
          ? this.$tr('vacancy.openRegistrationVideoresume.title')
          : this.$tr('vacancy.openRegistrationVideoresume.titleStages');
      }
    },

    disableRecord() {
      return (
        this.landing.is_disable_record_videointerview ||
        (this.interview && this.interview.vacancy && !this.interview.vacancy.is_active)
      );
    },

    isVideoresume() {
      if (!this.landing && this.isInterviewVideoresume) {
        return false;
      }
      return this.landing.is_videoresume || this.isInterviewVideoresume;
    },

    shouldShowDescr() {
      if (this.page_type == 'landing') return true;
      return this.isDescrVisible;
    },

    isPublicResponse() {
      return this.$route.name === 'open-registration';
    },

    isInterviewStarted() {
      if (this.interview && this.interview.active_modules && this.interview.active_modules.length) {
        return this.interview.active_modules.filter(item => item.is_started).length > 0;
      } else {
        return false;
      }
    },

    isDomainRu() {
      return isDomainRu();
    },

    custom_link() {
      return `${this.domain}${this.landing_token}`;
    },

    domain() {
      return `${window.location.origin}/r/`;
    },

    company_logo() {
      return this.landing.company ? this.landing.company.logo : false;
    },

    company_name() {
      return this.landing.company ? this.landing.company.name : false;
    },

    company_language() {
      return this.landing.company && this.landing.company.language ? this.landing.company.language.code : '';
    },

    responseToken() {
      return this.interview && this.interview.response_token ? this.interview.response_token : null;
    },

    vacancy_country() {
      return this.landing && this.landing.country ? this.landing.country.code : null;
    },

    is_japan_locale() {
      return this.$store.getters['locale/is_japan_locale'];
    },

    locale() {
      return this.$store.state.locale.value;
    },

    modules() {
      let result = [];
      let modules = [...this.landing.active_modules];
      let can_pass = true;

      if (this.page_type === 'interview') {
        modules = [...this.interview.active_modules];
      }
      if (this.page_type === 'interview' && this.landing && this.landing.is_resume_required) {
        result.unshift({
          id: 'resume',
          finished: this.interview.has_resume,
          name: this.$tr('interview.landing.resume.title'),
          description: !this.isVideoresume
            ? this.$tr('vacancy.openRegistration.resumeTitle')
            : this.$tr('vacancy.openRegistrationVideoresume.resumeTitle.main'),
          resumeName: this.interview.resume_url,
          resumeUrl: this.resumeUrl || this.interview.second_resume_url
        });
      }
      if (!this.isVideoresume) {
        result.unshift({
          id: 'registration',
          name: this.$tr('interview.landing.modules.reg.title'),
          finished: true,
          can_pass: false
        });
      }

      modules.forEach(i => {
        if (i.id === 'test' && i.name !== null && i.name !== '') {
          i.title = i.name;
        }
        result.push({
          id: i.id === 'videointerview' ? 'video' : i.id,
          title: i.title ? i.title : this.$tr(`interview.landing.modules.${i.id}.title`),
          name: i.name ? i.name : this.$tr(`interview.landing.modules.${i.id}.title`),
          description: i.description,
          button_text: this.$tr(`interview.landing.modules.${i.id}.button`),
          finished: i.is_finished,
          minutes_length: i.minutes_length,
          can_pass: this.vacancyStatus.canRegister ? can_pass : false
        });
        can_pass = i.is_finished;
      });

      return result;
    },

    hasValidResume() {
      if (this.resumeFile || !!this.hasResumeName) {
        return true;
      }
      if (this.resumeUrl) {
        return !this.resumevalError;
      }
      return false;
    },

    isResumeMandatory() {
      return this.landing.is_resume_mandatory;
    },

    isResumeFinished() {
      if (!this.interviewActiveModules || !this.interviewActiveModules.length) {
        return false;
      }

      return !!this.interviewActiveModules.every(item => item.is_finished);
    },

    isStagesDisabled() {
      if (!this.modules || !this.modules.length) {
        return false;
      }
      const resumeModule = this.modules.find(item => item.id === 'resume');

      if (!resumeModule) {
        return false;
      }
      return (
        this.page_type === 'interview' &&
        this.landing &&
        this.landing.is_resume_required &&
        this.landing.is_resume_mandatory &&
        !this.hasValidResume
      );
    },

    vacancyStatus() {
      const statuses = {
        deleted: {
          canRegister: false,
          text: this.$tr('vacancy.openRegistration.deleted'),
          className: 'red'
        },

        archived: {
          canRegister: false,
          text: this.$tr('vacancy.openRegistration.archived'),
          className: 'gray'
        },

        registrationIsClosed: {
          canRegister: false,
          text: this.$tr('vacancy.openRegistration.registrationIsClosed'),
          className: 'yellow'
        },

        active: {
          canRegister: true,
          text: null,
          className: null
        }
      };
      const status = !this.landing
        ? 'deleted'
        : this.landing.is_active === false
        ? 'archived'
        : this.landing.is_private && this.landing.is_active && this.reg
        ? 'registrationIsClosed'
        : 'active';
      return statuses[status];
    },

    formatted_candidate_name() {
      const candidate = this.interview.candidate;

      if (candidate) {
        if (this.is_japan_locale) {
          return `${candidate.surname} 様`;
        } else {
          return candidate.name;
        }
      } else {
        return false;
      }
    },

    no_refusal() {
      if (this.interview.refusal) {
        return false;
      }
      return true;
    },

    survey_finish() {
      return this.$store.getters['interview/application/finish'];
    },

    activeModules() {
      if (!this.landing) {
        return null;
      }

      return this.landing.active_modules;
    },

    interviewActiveModules() {
      if (!this.interview || !this.interview.active_modules || !this.interview.active_modules.length) {
        return null;
      }

      return this.interview.active_modules;
    },

    isAllModulesFinished() {
      if (!this.modules || !this.modules.length) {
        return true;
      }

      let finished = true;
      this.modules.forEach(item => {
        if (!item.is_finished && item.id !== 'resume') {
          finished = false;
        }
      });
      return finished;
    },

    hasVideo() {
      if (!this.activeModules || !this.activeModules.length) {
        return false;
      }

      let has_video = false;

      this.activeModules.forEach(activeModule => {
        if (activeModule.id === 'videointerview') {
          has_video = true;
        }

        if (activeModule.child_modules && activeModule.child_modules.length) {
          activeModule.child_modules.forEach(childModule => {
            if (childModule.id === 'anticheating') {
              has_video = true;
            }
          });
        }
      });
      return has_video;
    }
  },

  watch: {
    vacancy_country: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$store.commit('interview/set_country', val);
        }
      }
    },

    company_language: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$store.commit('interview/set_company_language', val);
        }
      }
    },

    isImagesLoaded: {
      immediate: true,
      handler(val) {
        if (val) {
          this.setWrapperHeight();
        }
      }
    }
  },

  created() {
    VueScrollTo.scrollTo(document.querySelector('.main'), 0);

    this.open_registration_title();
    if (this.page_type === 'interview') {
      this.reg = false;
    }

    if (this.getProcessName !== undefined) {
      if (this.getProcessName === PROCESS_NAMES.QMARKETING) {
        // eslint-disable-next-line
          gtag('config', 'UA-147625550-1', { groups: 'qmarketing' });
      }
    }
  },

  mounted() {
    this.setLinksTargetBlank();

    if (this.$refs.description_wrapper && this.page_type === 'interview') {
      const images = document.querySelectorAll('.description-wrapper img');
      if (!images.length) {
        this.setWrapperHeight();
      }
    } else {
      this.setWrapperHeight();
    }

    setTimeout(() => {
      if (!this.isPageLoaded) {
        this.setWrapperHeight();
      }
    }, 6000);

    // если есть данное свойство, то сразу переходить на указанный шаг (а также вакансия должна быть ОБЯЗАТЕЛЬНО активной)
    // Пока это использует MARS
    if (this.startGoto && !this.disableRecord) {
      this.set_page_stage(this.startGoto);
    }
  },

  beforeDestroy() {
    this.isSettingWrapperHeight = false;
  },

  methods: {
    check_captcha(v) {
      this.recaptcha_res = v;
    },

    reset_captcha() {
      this.recaptcha_res = null;
    },

    check_security() {
      if (this.error_code === 'captcha_required') {
        this.show_captcha = true;
      }
      this.disabled = false;
    },

    imageLoaded() {
      this.isImagesLoaded = true;
    },

    toggleDescription() {
      this.isDescrVisible = !this.isDescrVisible;
    },

    handleSubmit(interview) {
      this.disabled = true;
      this.error_code = null;

      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let source = '';

      if (params.get('src') !== null) {
        source = params.get('src');
      } else {
        source = document.referrer;
      }

      this.$store
        .dispatch('landing/validate', interview)
        .then(res => {
          if (res.data.errors) {
            this.customErrors = res.data.errors;
            throw new Error();
          }
          return this.$store.dispatch(
            'landing/save',
            Object.assign({}, interview, {
              source,
              captcha_token: this.recaptcha_res
            })
          );
        })
        .then(r => {
          const interview_token = r.data.data[0].interview.token;
          if (this.hasVideo) {
            localStorage.setItem('agree_video_' + interview_token, true);
          }

          this.$router.push({
            name: 'interview',
            params: {
              token: interview_token,
              fromRegistration: true
            }
          });
          this.disabled = false;
        })
        .catch(err => {
          const e = handleError(err);
          this.reset_captcha();

          console.log(err.message);
          // console.log(err.response.status);
          // console.log(err.response.headers);

          if (e.status === 400 || e.status === 429) {
            if (e.code !== undefined) {
              this.error_code = e.code;
            }
          } else {
            this.$noty.error(this.$tr('common.error'));
          }
          this.check_security(e);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    uploadResume(file) {
      this.resumeFile = file;
    },

    uploadResumeUrl(url) {
      this.resumeUrl = url;
    },

    setError(val) {
      this.resumevalError = val;
    },

    setResumeName(val) {
      this.hasResumeName = val;
    },

    resetFile() {
      this.resumeFile = null;
    },

    sendResume(v) {
      let interview = {
        vacancyToken: this.landing.token,
        responseToken: this.responseToken
      };
      if (this.resumeFile) {
        interview.resumeFile = this.resumeFile;
      }
      if (this.resumeUrl) {
        interview.resumeUrl = this.resumeUrl;
      }
      interview.hasResumeName = !!this.hasResumeName;

      this.stageLoading = true;
      this.$store
        .dispatch('landing/uploadResume', interview)
        .then(() => {
          this.stageLoading = false;
          this.isResumeUploaded = true;
          this.set_page_stage(v);
        })
        .catch(() => {
          this.stageLoading = false;
        });
    },

    goToCurrentStage() {
      const currentModules = this.modules.filter(item => !item.finished && item.id !== 'resume' && item.can_pass);

      const currentModuleId = currentModules[0].id;
      this.set_page_stage(currentModuleId);
    },

    set_page_stage(v) {
      if (this.page_type === 'interview' && this.landing && this.landing.is_resume_required && !this.isResumeUploaded) {
        const resumeModule = this.modules.find(item => item.id === 'resume');

        if (resumeModule && !resumeModule.finished && (this.resumeFile || this.resumeUrl)) {
          this.sendResume(v);
          return;
        }
      }

      if (v === 'video' || v === 'videointerview') {
        axios.put(`/1.0/interviews/${this.interview_token}/video_interviews/start`);
        this.$router.push({ name: 'record', params: { token: this.interview.token } });

        if (this.getProcessName !== undefined) {
          if (this.getProcessName === PROCESS_NAMES.QMARKETING) {
            // eslint-disable-next-line
              gtag('event', 'Start', {
              event_category: 'Video',
              event_label: 'Sales Manager',
              send_to: 'qmarketing'
            });
          }
        }
      } else if (v === 'survey') {
        // axios.put(`/1.0/interviews/${this.interview_token}/survey`);
        this.$router.push({ name: 'survey', params: { token: this.interview.token } });
      } else if (v === 'talentq') {
        // axios.put(`/1.0/interviews/${this.interview_token}/survey`);
        this.$router.push({
          name: 'interview-talentq-agree',
          params: { token: this.interview.token }
        });
      } else if (v === 'test') {
        if (v !== 'shl-test') {
          // в процессе feniche есть свой stage === 'shl-test', где не нужен редирект
          this.$router.push({ name: 'interview-test', params: { token: this.interview.token } });
        }
      } else if (v === 'integration') {
        this.$router.push({
          name: 'interview-integration',
          params: { token: this.interview.token }
        });
      }
    },

    open_registration_title() {
      if (this.landing && this.landing.name) {
        let title = this.$tr('pageTitles.prefix');
        title = `${this.landing.name}. ${this.company_name} - ${title}`;
        document.title = title;
      }
    },

    get_interview() {
      this.interview.token &&
        this.$store.dispatch('interview/videointerview/fetch', {
          interview: this.interview
        });
    },

    setWrapperHeight() {
      const isInterviewOpened = localStorage.getItem('interview_opened_' + this.interview_token);
      if (this.page_type === 'interview') {
        localStorage.setItem('interview_opened_' + this.interview_token, true);
      }

      if (this.isSettingWrapperHeight) {
        return;
      }
      if (this.page_type !== 'interview') {
        this.isDescrVisible = true;
        this.isPageLoaded = true;
        return;
      }
      this.isSettingWrapperHeight = true;

      this.isDescrVisible = !this.isInterviewStarted && !isInterviewOpened && !this.fromRegistration;

      this.maxHeight = this.$refs.description_wrapper.offsetHeight;

      if (this.$refs.description_wrapper.offsetHeight < 563) {
        this.showToggleDescriptionButton = false;
        this.isDescrVisible = true;
      }

      this.isPageLoaded = true;
    },

    setLinksTargetBlank() {
      const linksList = document.querySelectorAll('.description a');
      linksList.forEach(link => {
        if (link && link.href) {
          link.onclick = function openLink() {
            window.open(link.href);
            return false;
          };
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

#registration-content {
  .container-fixed {
    flex: 1;
    display: flex;
    align-items: center;
  }
  ::v-deep {
    .v-application {
      background: transparent !important;
      .greet {
        margin-bottom: 22px;
      }
      .description-wrapper {
        margin-bottom: 0;
      }
    }
    .v-application--wrap {
      min-height: calc(100vh - 4vw - 61px);
    }
  }
}
.image {
  margin: 0 auto 20px;
  min-height: 60px;
  display: flex;
  justify-content: center;
  img {
    display: block;
    max-width: 100%;
    max-height: 60px;
    min-height: 60px;
  }
}
.greet {
  text-align: center;
  margin-bottom: 40px;
  max-width: 100%;
  h1 {
    font-weight: 500;
    line-height: normal;
    font-size: 28px;
    margin-bottom: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    padding: 0;
  }
}
.tightContainer.container {
  // max-width: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  margin: -20px auto -30px;
  padding: 37px 88px 40px;
  background: white;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0;
    margin-bottom: 30px;
  }

  .container-content {
    width: 100%;
  }
}
.landing_content_block {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 608px;
  width: 100%;

  ul {
    list-style: disc !important;
  }
}
.refuse-container {
  width: 800px;
  height: 542px;
  margin: 2vw auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-sizing: border-box;
  box-shadow: 0px 1px 40px rgba(28, 50, 75, 0.05);

  @media (max-width: 768px) {
    padding: 0;
  }
  &__wrap {
    max-width: 500px;
    color: #233346;
    text-align: center;
  }
  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 41px;
    margin-top: 25px;
  }
}
.container {
  margin: 0 auto;
  button.vcv-button {
    font-weight: normal;
    text-transform: uppercase;
    width: 182px;

    @media (max-width: 768px) {
      width: auto;
      max-width: 206px;
      margin-bottom: 40px;
    }
  }

  & > button.vcv-button {
    @media (max-width: 768px) {
      margin-bottom: 40px;
    }
  }

  p.link {
    margin-top: 25px;
    font-size: 12px;
    font-weight: 300;
    color: #a6a6a6;
  }

  p.terms {
    margin-top: 18px;
    font-size: 10px;
    font-weight: 300;
    color: #a6a6a6;
  }
}

.vacancy-logo {
  width: 100%;
  margin-bottom: 40px;

  img {
    width: 100%;
  }
}

.vacancy-share {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 23px;
  font-size: 15px;
  font-weight: 500;

  span {
    margin-right: 8px;
  }

  ::v-deep .round-icon {
    height: 35px;
    width: 35px;
    fill: #9b9b9b;
    color: #9b9b9b;
    cursor: pointer;

    &:focus,
    &:active {
      outline: none;
    }

    &:hover {
      fill: #333333;
      color: #333333;
    }
  }
}

.interview_top_block {
  width: 100%;
  box-sizing: border-box;
}

.closed {
  padding: 10px;
  text-align: center;
  font-size: 15px;
  line-height: 22px;
  width: 100%;
  &.gray {
    background: rgba(215, 220, 224, 0.5) !important;
    color: #333333 !important;
    border-color: transparent !important;
  }
  &.red {
    background: rgba(254, 64, 53, 0.15) !important;
    color: #f65046 !important;
    border-color: transparent !important;
  }
  &.yellow {
    background: rgba(254, 167, 64, 0.15) !important;
    color: #fd971d !important;
    border-color: transparent !important;
  }
}

.description-wrapper {
  margin-bottom: 20px;
  width: 100%;
  overflow-y: hidden;
  transition: max-height 1s ease-in;
  position: relative;

  &.is-hidden {
    max-height: 563px !important;
    transition: max-height 1s ease-out;

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 350px;
      background: linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
    }
  }
}
.description.description-text {
  max-width: 100%;
  width: 100%;
  white-space: pre-wrap;

  ::v-deep ul,
  ::v-deep ol {
    padding-left: 15px;
  }
  ::v-deep img {
    width: 100%;
    max-width: 100%;
  }
  ::v-deep {
    *:not(a):not([class*='ql-font'] *) {
      font-size: 15px;
      line-height: 22px;
      box-sizing: border-box;
    }

    h1 {
      margin: 0;
      padding: 0;
      margin-top: 0 !important;
      margin-bottom: 30px !important;
      font-size: 28px !important;
      line-height: normal !important;
      font-weight: 400 !important;
    }

    h2 {
      margin: 0;
      padding: 0;
      padding: 15px 0 10px 0 !important;
      font-size: 22px !important;
      line-height: normal !important;
      font-weight: 400 !important;
    }

    h1 + h2 {
      padding-top: 0 !important;
    }

    a {
      color: $green !important;
      text-decoration: none !important;
    }

    ol,
    ul {
      margin: 0;
      padding: 0;
      padding-left: 30px !important;
      margin-left: 0 !important;
    }

    ul {
      list-style: disc !important;
    }

    li {
      padding-left: 0 !important;
    }
  }
}
.landing_modules {
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;

  .landing_modules_title {
    margin-bottom: 12px;
    word-wrap: break-word;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    color: #233346;

    &.landing-title {
      margin-bottom: -8px;
      font-style: normal;
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
      text-align: center;
      color: #233346;
    }
  }
  .landing_module {
    border-top: 1px solid #ebedf0;
    padding-top: 20px;
    padding-bottom: 20px;
    .landing_title {
      color: #333;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-size: 18px;
      height: 45px;
      line-height: 45px;
      padding-left: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      background: url('/static/icons/landing_ok.png') left center no-repeat;
    }
    &:first-child {
      border-top: 0;
    }
    &.reg {
      .landing_title {
        background: url('/static/icons/landing_reg.png') left center no-repeat;
      }
    }
  }
  .interview_button {
    margin-top: 20px;
    margin-left: 60px;
  }
  .interview_button {
    margin-top: 20px;
    margin-left: 60px;
  }
}
.landing_share {
  width: 608px;
}
.landing_share {
  width: 608px;
}

@media (max-width: 768px) {
  .landing_share {
    width: 100%;
  }

  .vacancy-share {
    flex-flow: column;

    & span {
      margin-bottom: 10px;
    }
  }
}

.prepare_page {
  opacity: 0;
  transition: opacity linear 0.3s;
  @media (max-width: 768px) {
    background: white;
  }

  &.is-visible {
    opacity: 1;
  }

  .toggle-description-link {
    display: inline-flex;
    align-self: flex-start;
    margin-bottom: 25px;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
    color: #9faab6;
    cursor: pointer;

    span {
      transition: opacity ease-in-out 0.5s;
      opacity: 1;
      visibility: visible;

      &.is-hidden {
        opacity: 0;
        visibility: hidden;
        position: absolute;
        transition: opacity ease-in-out 0.5s;
      }
    }
  }

  .is-videoresume {
    .image {
      margin: 0 auto 52px;
      min-height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
        min-height: auto;
      }
      img {
        display: block;
        max-width: 100%;
        max-height: 70px;
        min-height: 70px;
        @media (max-width: 768px) {
          min-height: auto;
        }
      }
    }

    .greet {
      margin-bottom: 20px;

      h1 {
        margin-bottom: 0;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0;
        padding: 0;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
        color: #555555;
      }

      h1 {
        margin: 0;
        padding: 0;
        margin-top: 0 !important;
        margin-bottom: 30px !important;
        font-size: 28px !important;
        line-height: normal !important;
        font-weight: 400 !important;
      }

      h2 {
        margin: 0;
        padding: 0;
        padding: 15px 0 10px 0 !important;
        font-size: 22px !important;
        line-height: normal !important;
        font-weight: 400 !important;
      }

      h1 + h2 {
        padding-top: 0 !important;
      }

      a {
        color: $green !important;
        text-decoration: none !important;
      }

      ol,
      ul {
        margin: 0;
        padding: 0;
        padding-left: 30px !important;
        margin-left: 0 !important;
      }

      li {
        padding-left: 0 !important;
      }
    }

    .landing_content_block {
      max-width: 600px;
    }

    .interview_button {
      margin-top: 0;
    }
    .landing_modules_title {
      font-style: normal;
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
      text-align: center;
      color: #555555;
      margin-bottom: 34px;
      word-wrap: break-word;

      .description-wrapper {
        margin-bottom: 51px;
      }
      .description.description-text {
        max-width: 100%;
        width: 100%;
        white-space: pre-wrap;

        ::v-deep {
          * {
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            line-height: 24px;
            color: #8d8d8d;
            box-sizing: border-box;
          }
        }
      }

      .landing_modules {
        margin-top: 0;

        .landing_modules_title {
          font-style: normal;
          font-weight: 500;
          font-size: 28px;
          line-height: 41px;
          text-align: center;
          color: #555555;
          margin-bottom: 34px;
          word-wrap: break-word;

          &.landing-title {
            margin-bottom: 20px;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 32px;
            text-align: center;
          }
        }
        .landing_module {
          border-top: 0;
          padding-top: 0;
          padding-bottom: 0;
        }
      }

      .vacancy-share {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 51px;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        color: #8d8d8d;

        // span {
        //   margin-right: 10px;
        // }

        ::v-deep .round-icon {
          height: 35px;
          width: 35px;
          fill: #c4b9d3;
          color: #c4b9d3;
          cursor: pointer;

          &:focus,
          &:active {
            outline: none;
          }
        }
        .landing_module {
          border-top: 0;
          padding-top: 0;
          padding-bottom: 0;
        }
      }

      .vacancy-share {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 51px;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        color: #8d8d8d;

        // span {
        //   margin-right: 10px;
        // }

        ::v-deep .round-icon {
          height: 35px;
          width: 35px;
          fill: #c4b9d3;
          color: #c4b9d3;
          cursor: pointer;

          &:focus,
          &:active {
            outline: none;
          }
        }
        .landing_module {
          border-top: 0;
          padding-top: 0;
          padding-bottom: 0;
        }
      }

      &:hover {
        fill: #ac97c8;
        color: #ac97c8;
        transition: color ease 0.3s;
      }
      ::v-deep {
        .sharing-list-wrapper {
          position: relative;
        }
        .sharing-list {
          position: relative;
          display: flex;
          align-items: center;
          position: relative;

          &:before {
            content: attr(title);
            position: absolute;
            top: calc(50% - 12px);
            right: calc(100% + 10px);
          }

          span {
            display: flex;
            height: 35px;
            width: 35px;
            justify-content: center;
            align-items: center;

            &:not(:last-child) {
              margin-right: 8px;
            }
          }
        }
      }
    }
  }

  .stages-footer {
    display: flex;
    justify-content: flex-end;
  }

  .inner_wrapper {
    position: relative;
    background-color: #fff;
    padding: 40px 0;
    box-sizing: border-box;
    margin: auto 0;
    min-width: 320px;
    width: 100%;

    &.nocamera {
      padding: 120px 0 80px;
    }

    .logo {
      height: 60px;
      max-height: 60px;
      min-height: 60px;
      margin-bottom: 52px;
      img {
        height: 100%;
      }

      @media (max-width: 1000px) {
        text-align: center;
      }
    }
    .info-text {
      .info-title {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        color: #233346;
      }
    }
    .agree {
      margin-bottom: 30px;
    }
  }
}
</style>
